<template>
    <div class="modal fade" :id="modalId" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
        :aria-labelledby="modalId" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-5" id="staticBackdropLabel">{{ ModalTitle }}</h1>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <form @submit.prevent="$parent[modalSubmitFnc]">
                    <div class="modal-body">
                        <div class="">
                            <h5 class="col-form-label"></h5>
                        </div>
                        <div class="container justify-content-center">
                            <div class="form-check form-check-inline">
                                <input v-model="inputFields.appType.value" class="form-check-input" type="radio" id="type-export" value="1"/>
                                <label class="form-check-label" for="search-nation">خروج من ليبيا (تصدير مؤقت)</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input v-model="inputFields.appType.value" class="form-check-input" type="radio" id="type-import" value="2"/>
                                <label class="form-check-label" for="search-reg">دخول ليبيا (استيراد مؤقت)</label>
                            </div>
                        </div>
                        <div class="input-field my-2 d-inline-flex w-100">
                            <label class="fake-placeholder"></label>
                            <select class="form-select" id="nationalityId" v-model="inputFields.nationalityId.value" required="">
                                <option data-hidden="true" selected="" disabled="" value="">جنسية السائق</option>
                                <option value="1">ليبي</option>
                                <option value="2">مصري</option>
                            </select>
                        </div>
                        <div class="input-field my-2 d-inline-flex w-100" v-if="this.inputFields.nationalityId.value == 1/* isLibyan */">
                            <label class="fake-placeholder"></label>
                            <input type="text" id="nationNo" v-model="inputFields.nationNo.value" class="w-100 form-control"
                                placeholder="الرقم الوطني" required="" pattern="^[0-9۰-۹]{12}$">
                        </div>
                        <div class="input-field my-2 d-inline-flex w-100" v-if="this.inputFields.nationalityId.value != 1/* isLibyan */">
                            <label class="fake-placeholder"></label>
                            <input type="text" id="passNo" v-model="inputFields.passNo.value" class="w-100 form-control"
                                placeholder="رقم الجواز" required="" pattern="[0-9۰-۹a-zA-Z]{6,13}">
                        </div>
                        <div class="input-field my-2 d-inline-flex w-100">
                            <label class="fake-placeholder"></label>
                            <select class="form-select" id="departId" v-model="inputFields.departId.value" required="">
                                <option data-hidden="true" selected="" disabled="" value="">اختر المعبر الحدودي</option>
                                 <option v-for="option in inputFields.departId.options" :key="option.id" :value="option.id">
                                    {{ option.name }}
                                </option>
                                <!-- <option value="2">مركز جمرك امساعد البري</option> -->
                            </select>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">{{ $t("close")
                            }}</button>
                        <button type="submit" id="new-email-submit" data-bs-dismiss="" class="btn btn-primary"
                           >{{ $t(modalSubmitText) }}</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import router from '@/router';

export default {
    name: "NewAppModal",
    // data() {
    //     return {
    //         inputFields: {
    //             nationNo: null,
    //             depart: null,
    //             passNo: null,
    //             nationalityId: 1,
    //         },    //     }
    // },
    props: {
        modalId: {
            default: "staticGeneralModal",
            type: String
        },
        ModalTitle: String,
        ModalFormLabel: String,
        ModalPlaceholder: String,
        inputFields: Object,
        modalSubmitFnc: {
            default: "modalSubmitFnc",
            type: String
        },
        modalSubmitText: {
            default: "submit",
            type: String
        }
    },
    computed: {
        // isLibyan: function () {
        //     return (this.inputFields.nationalityId.value == 1) ? true : false;
        // }
        compAppType: function () {
            return this.inputFields.appType.value ;
        }
    },
    watch: {
        compAppType: function(v){
            this.inputFields.nationalityId.value = v;
        } 
    },
    methods: {
        submitModal() {
            router.push({ name: 'applicant' })
        }
    }
}
</script>